import './style.css'

interface ProgressIndicatorProps {
  currentStep: number
  totalSteps: number
}

export const ProgressIndicator = ({ currentStep, totalSteps }: ProgressIndicatorProps) => {
  return (
    <div className="progress-container" data-tour="wizard-progress">
      <div className="progress-container-text">
        <span className="progress-container-text-number">
          {String(currentStep).padStart(2, '0')}
        </span>
        <span className="progress-container-text-separator">/</span>
        <span className="progress-container-text-total">{String(totalSteps).padStart(2, '0')}</span>
      </div>
    </div>
  )
}
